module.exports = __webpack_public_path__ + "img/no-data.3eb05191.svg";